<template>
  <div>
    <h1>Oops, looks like something went wrong!</h1>
    <router-link to="/">
        <b-button class="submit" variant="primary" type="submit">Back to Home</b-button>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: "SubmissionFailed"
  }
</script>

<style lang="scss">
  .submit{
    margin-top: 40px;
  }
</style>